import { HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { InMemoryCache } from '@apollo/client/core';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { APOLLO_NAMED_OPTIONS, provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from 'environments/environment';
import { createClient } from 'graphql-ws';

const ACADEMY_GRAPHQL_ENDPOINT = environment.graphql.academy_endpoint;
const ACADEMY_GRAPHQL_ENDPOINT_WSS = environment.graphql.academy_endpoint_wss;

export const provideAppGraphql = [
  provideApollo(() => {
    const httpLink = inject(HttpLink);
    return {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: ACADEMY_GRAPHQL_ENDPOINT,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    };
  }),
  {
    provide: APOLLO_NAMED_OPTIONS,
    useFactory: (): Record<string, unknown> => {
      const httpLink = inject(HttpLink);
      return {
        AcademyGraphQLEndpoint: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: ACADEMY_GRAPHQL_ENDPOINT,
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          }),
        },
        AcademyGraphQLEndpointWSS: {
          cache: new InMemoryCache({
            typePolicies: {},
          }),
          link: new GraphQLWsLink(
            createClient({
              url: ACADEMY_GRAPHQL_ENDPOINT_WSS,
            })
          ),
        },
      };
    },
    deps: [HttpLink],
  },
];
